export default "__VITE_ASSET__CiQPuBJt__"